import cn from 'classnames'
import React, { Dispatch, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CheckBox } from 'src/components/global/CheckBox/CheckBox'
import { IEnum_Solution_Type } from 'src/graphql/generated/hooks'
import { useAuthenticated } from 'src/hooks/useAuthenticated'
import { updateCompareBySlug } from 'src/store/actions/compare'
import { showToast } from 'src/store/actions/toastAction'
import { AppState } from 'src/store/types'
import { CompareInfos } from 'src/store/types/compare'
import { CompareSolution } from 'src/types'

import { SignUpModal } from './SignUpModal'
import { VerifyEmailModal } from './VerifyEmailModal'

export interface CompareButtonProps {
  slug: string
  solutionType: IEnum_Solution_Type
  className?: string
  isCheckShow?: boolean
}

/**
 * Primary UI component for user interaction
 */
export const CompareButton = ({ slug, solutionType, className, isCheckShow }: CompareButtonProps) => {
  const [compare, setCompare] = useState(false)

  const { status, session } = useAuthenticated()
  const email = session?.user.email || ''
  const confirmed = session?.user.confirmed || false
  const [showSignUp, setShowSignUp] = useState(false)
  const [showEmailVerify, setShowEmailVerify] = useState(false)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const dispatch: Dispatch<any> = useDispatch()
  const compares: CompareInfos = useSelector((state: AppState) => state.compareInfos)

  useEffect(() => {
    const isFound = compares.solutions.find((item) => item.slug === slug)
    setCompare(!!isFound)
  }, [compares, slug])

  const handleCompare = () => {
    if (status !== 'authenticated') {
      setShowSignUp(true)
    } else if (confirmed === false) {
      setShowEmailVerify(true)
    } else {
      const solutions = compares.solutions
      const isFound = solutions.find((item) => item.slug === slug)

      if (!isFound) {
        if (solutions.length >= 5) {
          dispatch(showToast('You can only compare 5 solutions at a time.', 'info'))
          return
        }
        if (solutions.length > 0) {
          const firstSolutionType = solutions[0].solutionType
          if (
            (firstSolutionType === IEnum_Solution_Type.Alsp && solutionType !== IEnum_Solution_Type.Alsp) ||
            (firstSolutionType === IEnum_Solution_Type.Consultancy &&
              solutionType !== IEnum_Solution_Type.Consultancy) ||
            (firstSolutionType === IEnum_Solution_Type.Product && solutionType !== IEnum_Solution_Type.Product)
          ) {
            dispatch(showToast('Model is different. Please select another.', 'info'))
            return
          }
        }
        setCompare(true)
        const vendorInfo: CompareSolution = {
          id: '',
          logo: '',
          slug: slug,
          solutionType,
        }
        dispatch(updateCompareBySlug(vendorInfo, false))
      } else {
        setCompare(false)
        dispatch(updateCompareBySlug({ slug: slug } as CompareSolution, true))
      }
    }
  }

  const handleCloseSignUp = () => {
    setShowSignUp(false)
  }

  const handleCloseEmailVerify = () => {
    setShowEmailVerify(false)
  }

  return (
    <div className={cn('flex justify-center text-textdark cursor-pointer w-full h-[42px]', className)}>
      <CheckBox
        label="Compare"
        selected={compare}
        indeterminate={compare}
        onChanged={handleCompare}
        isCheckShow={isCheckShow}
      />
      <SignUpModal isOpen={showSignUp} onClose={handleCloseSignUp} />
      <VerifyEmailModal isOpen={showEmailVerify} email={email} onClose={handleCloseEmailVerify} />
    </div>
  )
}

export default CompareButton
